import { SimpleChanges } from "@angular/core";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from "@angular/core";
import { DrawerModule } from "primeng/drawer";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { ProductionWorkflowSummaryComponent } from "../../project-workflow/production-workflow-summary/production-workflow-summary.component";
import { TaskCalendarViewComponent } from "../../../shared/components/task-sidebar/task-calendar-view/task-calendar-view.component";
import { ToDoListComponent } from "../../../shared/components/task-sidebar/to-do-list/to-do-list.component";
import { CollaboratorsComponent } from "../../../shared/components/task-sidebar/collaborators/collaborators.component";
import { RemindersComponent } from "../../../shared/components/task-sidebar/reminders/reminders.component";
import { LinkedTaskComponent } from "../../../shared/components/task-sidebar/linked-task/linked-task.component";
import { ActivityLogComponent } from "../../../shared/components/task-sidebar/activity-log/activity-log.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-task-sidebar",
  templateUrl: "./task-sidebar.component.html",
  styleUrls: ["./task-sidebar.component.scss"],
  imports: [
    DrawerModule,
    ModalStackerComponent,
    ProductionWorkflowSummaryComponent,
    TaskCalendarViewComponent,
    ToDoListComponent,
    CollaboratorsComponent,
    RemindersComponent,
    LinkedTaskComponent,
    ActivityLogComponent,
    CommonModule,
  ],
})
export class TaskSidebarComponent implements OnChanges {
  @Input() display = false;
  @Input() displayAddTaskModal!: boolean;
  @Output() hideEvent = new EventEmitter();
  workflowId!: number;
  salesOrderId!: string;
  displayProdWorkflowSummary = false;
  refreshTasks = false;

  onHide() {
    this.hideEvent.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes["displayAddTaskModal"] &&
      !changes["displayAddTaskModal"].currentValue
    ) {
      this.refreshTasks = false;
      setTimeout(() => (this.refreshTasks = true), 0);
    }
  }

  workflowSummary(event: { salesOrderId: string; workflowId: number }) {
    if (event.salesOrderId && event.workflowId) {
      this.salesOrderId = event.salesOrderId;
      this.workflowId = event.workflowId;
      this.displayProdWorkflowSummary = true;
      this.hideEvent.emit();
    }
  }

  closeWorkflowModal() {
    this.displayProdWorkflowSummary = false;
    this.refreshTasks = true;
  }

  closeSideBar() {
    this.display = false;
  }
}
